var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useEffect } from 'react';
import { useAuth, detectLocation, Place, Story, Chat, leaveComment, voteUp, closeObject, useLoadObjects, PointingSegment, useLoadSingleObject, ProfileWidget, NavigationWidget, Maps, MapItem, AuthProvider, } from '..';
import { RenderAuthorProvider } from '../utils/renderAuthor';
import { Modal, Loader } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
var isDEV_ENV = process.env.NODE_ENV === 'development';
var CommunityMapImpl = function (_a) {
    var onChange = _a.onChange, centerPin = _a.centerPin, center = _a.center, data = _a.data, zoom = _a.zoom, defaultCenter = _a.defaultCenter, defaultZoom = _a.defaultZoom, renderObject = _a.renderObject, renderAuthor = _a.renderAuthor, showZoomControls = _a.showZoomControls, profileWidget = _a.profileWidget, navigationWidget = _a.navigationWidget, autolocate = _a.autolocate, filterOrigin = _a.filterOrigin, mapStyles = _a.mapStyles, mapApiKey = _a.mapApiKey, onClickObject = _a.onClickObject, extShowObjectId = _a.showObjectId, onObjectModalClose = _a.onObjectModalClose;
    var user = useAuth() || null;
    var _b = useState(null), mapParams = _b[0], setMapParams = _b[1];
    var _c = useState(null), autodetectedCenter = _c[0], setAutodetectedCenter = _c[1];
    var doAutolocate = useCallback(function () {
        return detectLocation()
            .then(function (loc) {
            console.debug('Autolocate:', loc);
            setAutodetectedCenter(loc);
        })
            .catch(function (err) {
            console.log('Error autodetecting location:', err);
            // silently ignore for the moment
        });
    }, [setAutodetectedCenter]);
    useEffect(function () {
        autolocate && doAutolocate();
    }, [doAutolocate]);
    var loadedObjects = useLoadObjects((mapParams === null || mapParams === void 0 ? void 0 : mapParams.bounds) || null, user, filterOrigin, !!data);
    var objects = data || loadedObjects;
    var render = function (props) {
        var rend = renderObject || defaultObjectRender;
        var itemView = rend(props);
        if (!itemView)
            return null;
        if (itemView === true)
            return defaultObjectRender(props);
        return itemView;
    };
    var _d = useState(null), intShowObjectId = _d[0], setIntShowObjectId = _d[1];
    var showObjectId = extShowObjectId || intShowObjectId;
    var onModalClose = useCallback(function () {
        onObjectModalClose === null || onObjectModalClose === void 0 ? void 0 : onObjectModalClose();
        setIntShowObjectId(null);
    }, [setIntShowObjectId, onObjectModalClose]);
    if (isDEV_ENV && mapParams && mapParams.bounds.maxLat === undefined) {
        return (React.createElement("div", { style: { color: 'red' } }, "Make sure the container element has width and height. The map will try to fill the parent container, but if the container has no size, the map will collapse to 0 width / height."));
    }
    return (React.createElement(RenderAuthorProvider, { value: renderAuthor },
        React.createElement(Maps, { styles: mapStyles, mapApiKey: mapApiKey, centerPin: centerPin, center: autodetectedCenter || center, zoom: zoom, defaultCenter: defaultCenter, defaultZoom: defaultZoom, showZoomControls: showZoomControls, onChange: function (center, bounds, zoom) {
                setMapParams({ center: center, bounds: bounds });
                setAutodetectedCenter(null);
                onChange === null || onChange === void 0 ? void 0 : onChange(center, bounds, zoom);
            } }, !!objects &&
            objects.map(function (it) {
                var defaultOnClickHandler = function () {
                    if (onClickObject && !onClickObject(it))
                        return;
                    setIntShowObjectId(it.id);
                };
                return (React.createElement(MapItem, { key: it.id, lat: it.loc.latitude, lng: it.loc.longitude }, render({
                    item: it,
                    defaultOnClickHandler: defaultOnClickHandler,
                    expanded: false,
                    currentUser: user,
                })));
            })),
        React.createElement(Modal, { open: !!showObjectId, onClose: onModalClose, closeIcon: true },
            React.createElement(Modal.Content, { scrolling: true }, !!showObjectId && (React.createElement(ExpandedObjectView, { objectId: showObjectId, renderObject: renderObject })))),
        profileWidget !== undefined ? profileWidget : React.createElement(ProfileWidget, null),
        navigationWidget !== undefined ? (navigationWidget) : (React.createElement(NavigationWidget, { onChangePosition: function (loc) { return setAutodetectedCenter(loc); } }))));
};
export var CommunityMap = function (props) {
    return (React.createElement(AuthProvider, null,
        React.createElement(CommunityMapImpl, __assign({}, props))));
};
var ExpandedObjectView = function (_a) {
    var objectId = _a.objectId, renderObject = _a.renderObject;
    var user = useAuth() || null;
    var object = useLoadSingleObject(objectId, user);
    if (object === undefined)
        return React.createElement(Loader, { active: true });
    if (object === null)
        return React.createElement("div", null, "Object not found :(");
    var render = function (props) {
        var rend = renderObject || defaultObjectRender;
        var itemView = rend(props);
        if (!itemView)
            return null;
        if (itemView === true)
            return defaultObjectRender(props);
        return itemView;
    };
    return (React.createElement(React.Fragment, null, render({
        item: object,
        expanded: true,
        currentUser: user,
    })));
};
var defaultObjectRender = function (_a) {
    var item = _a.item, currentUser = _a.currentUser, expanded = _a.expanded, defaultOnClickHandler = _a.defaultOnClickHandler;
    var RealComponent;
    switch (item.type) {
        case 'place':
            RealComponent = Place;
            break;
        case 'story':
            RealComponent = Story;
            break;
        default:
            RealComponent = Chat;
    }
    var comp = (React.createElement(RealComponent, { item: item, user: currentUser, onClick: defaultOnClickHandler, onComment: function (comment) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, leaveComment(currentUser, item, comment)];
        }); }); }, onVote: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, voteUp(currentUser, item)];
        }); }); }, onClose: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, closeObject(currentUser, item)];
        }); }); }, expanded: expanded }));
    return expanded ? comp : React.createElement(PointingSegment, null, comp);
};
//# sourceMappingURL=CommunityMap.js.map